import classnames from 'classnames';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

import { Grid } from '../Grid/Grid';
import { useSkipExportRenderingCallback } from './hooks/UseSkipExportRenderingCallback';
import { BuildChartOptions } from './Factories';
import { chartContainerStyle as containerStyle } from './shared/Config';

import * as styles from './DoubleBarChart.module.scss';
import ComparisonColumnChange from './components/ComparisonColumnChange';

export interface ComparisonOptions {
  isComparisonChart: boolean;
  title: string;
  data: string[];
  rowHeight: number;
  hoveredRowIndex: number | null;
  columnEnabled?: boolean; // workaround in order to hide contribution column of advanced segmentation bar chart
}

export type DoubleBarChartProps = {
  callback?: Highcharts.ChartCallbackFunction;
  options: BuildChartOptions;
  chartContainerStyle?: Record<string, unknown>;
  className?: any | string;
  immutable?: boolean;
  comparisonOptions?: ComparisonOptions;
};
const DoubleBarChart = ({
  options,
  callback = () => void 0,
  chartContainerStyle,
  className,
  immutable = true,
  comparisonOptions,
}: DoubleBarChartProps): JSX.Element => {
  callback = useSkipExportRenderingCallback(callback);
  return (
    <Grid
      className={classnames(styles.DoubleBarChartContainer, {
        [className]: className,
      })}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        callback={callback}
        immutable={immutable}
        containerProps={{ style: chartContainerStyle || containerStyle }}
        allowChartUpdate={!comparisonOptions?.isComparisonChart}
      />
      {comparisonOptions?.isComparisonChart && comparisonOptions?.columnEnabled && (
        <ComparisonColumnChange comparisonOptions={comparisonOptions} />
      )}
    </Grid>
  );
};

export default DoubleBarChart;
